import { render, staticRenderFns } from "./Terms_Conditions.vue?vue&type=template&id=7cd51f23&scoped=true&"
import script from "./Terms_Conditions.vue?vue&type=script&lang=js&"
export * from "./Terms_Conditions.vue?vue&type=script&lang=js&"
import style0 from "./Terms_Conditions.vue?vue&type=style&index=0&id=7cd51f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd51f23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
